import type { Item } from '../../api/types';
import { isTempId } from '../../api/hooks';
import { IconButton } from '../../ui/Button';
import { IconCheck, IconTrash } from '../../ui/icons';

export function ItemRow({
  item,
  onToggle,
  onDelete,
}: {
  item: Item;
  onToggle: (item: Item) => void;
  onDelete: (item: Item) => void;
}) {
  const pending = isTempId(item.id);
  return (
    <li
      className={`flex items-center rounded-2xl border border-line bg-surface pr-1 shadow-sm transition-opacity ${
        pending ? 'opacity-60' : ''
      }`}
    >
      <button
        type="button"
        role="checkbox"
        aria-checked={item.done}
        disabled={pending}
        onClick={() => onToggle(item)}
        className="flex min-h-14 min-w-0 flex-1 items-center gap-3.5 rounded-2xl py-2 pr-2 pl-4 text-left"
      >
        <span
          aria-hidden="true"
          className={`grid size-6 shrink-0 place-items-center rounded-full border-2 transition-colors ${
            item.done ? 'border-accent bg-accent text-on-accent' : 'border-subtle bg-transparent text-transparent'
          }`}
        >
          <IconCheck size={14} strokeWidth={3.5} />
        </span>
        <span
          className={`min-w-0 flex-1 text-base break-words transition-colors ${
            item.done ? 'text-subtle line-through decoration-subtle/70' : 'text-ink'
          }`}
        >
          {item.text}
        </span>
      </button>
      <IconButton
        label={`Delete ${item.text}`}
        disabled={pending}
        onClick={() => onDelete(item)}
        className="text-subtle hover:text-danger"
      >
        <IconTrash size={20} />
      </IconButton>
    </li>
  );
}
